<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen ">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45 mb-0">
            (RE)DESCUBRIENDO A ANGÉLICA PALMA:<br> <span class="fontMS500 colorPrincipal font-45">UNA VOZ PROPIA EN LA HISTORIA</span>
        </p>
        <p class="fontMS500 colorPrincipal font-24"></p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio40/angelica-palma">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio40/angelica-palma">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio40/angelica-palma">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-000.png">
</section>

<div class="fondoBlanco_Intro mt-1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS300 text-center font-24">
                    <br><br>
                    LA OBRA DE ANGÉLICA PALMA (1878-1935) HA SIDO FRECUENTEMENTE ESTUDIADA EN RELACIÓN CON LA FIGURA DE SU
                    PADRE RICARDO PALMA (1833-1919), CUYA INFLUENCIA EN LA TRADICIÓN LITERARIA HA SIDO DETERMINANTE EN LA
                    CONSTRUCCIÓN DE LA MEMORIA CULTURAL DEL PERÚ. SIN EMBARGO, ESTA FILIACIÓN HA ORIGINADO UNA LECTURA
                    PARCIAL DE SU PRODUCCIÓN, PRIVILEGIANDO SU ROL COMO HEREDERA Y EDITORA DEL LEGADO PATERNO, EN
                    DETRIMENTO DE SU IDENTIDAD COMO ESCRITORA Y PERIODISTA CON UNA VOZ PROPIA.
                    <br><br>

                    <br>
                </p>
                <div class="row p-5" style="display: flex; gap: 0;">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <div style="display: flex; width: 95%; ">
                            <div style="flex: 1; background-color: #424342; display: flex; justify-content: center; align-items: center; color: white; text-align: center;">
                                <p class="font-14 fontMS300Italic">Pasaporte de Angélica Palma de la<br>
                                    delegación peruana para el Congreso<br>
                                    Interamericano de Mujeres <br>
                                    Disponible en: <a href="http://hdl.handle.net/20.500.14428/80697" target="_blank" style="color: #ffffff;">Biblioteca Digital</a></p>
                            </div>
                            <div style="flex: 1; display: flex; justify-content: center; align-items: center;">
                                <a href="http://hdl.handle.net/20.500.14428/80697" target="_blank" style="color: #ffffff;">
                                    <img  style="width:100%; height: auto; object-fit: cover;" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-001.png">
                                </a>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <p class="fontMS300 text-center font-24">
                    <br><br>
                    ANGÉLICA PALMA DESARROLLÓ SU LABOR LITERARIA Y PERIODÍSTICA EN UN PERIODO EN EL QUE LAS
                    ESCRITORAS LATINOAMERICANAS ENFRENTABAN MÚLTIPLES OBSTÁCULOS PARA OBTENER
                    RECONOCIMIENTO EN UN ESPACIO DOMINADO POR FIGURAS MASCULINAS.
                    <br><br>

                    <br>
                </p>

                <div class="row p-3" style="display: flex; gap: 0; background-color: #424342; color: white;">
                    
                    <div class="col-sm-12">
                        <div style="display: flex; width: 100%; justify-content: space-between; align-items: flex-start;">
                            <!-- Lado izquierdo con el texto alineado a la izquierda -->
                            <div class="p-3" style="flex: 1; display: flex; justify-content: flex-start; align-items: center; text-align: right; line-height: 2;">
                                <p class="font-16 fontMS300"><br>
                                    SU PRODUCCIÓN INCLUYÓ NOVELAS, ENSAYOS Y ARTÍCULOS EN LA PRENSA, QUE ABORDARON TEMAS SOCIALES Y CULTURALES CON UNA PERSPECTIVA MODERNA. 
                                    SI BIEN SU TRABAJO EN LA CONSERVACIÓN Y DIFUSIÓN DE LA OBRA DE SU PADRE ES INNEGABLE, SU ESCRITURA TRASCIENDE ESTA FUNCIÓN Y 
                                    MERECE SER REESTUDIADA Y REVALORADA. DESDE ESTA PERSPECTIVA, SU ESTUDIO PERMITE PROBLEMATIZAR LA MANERA EN QUE LA LITERATURA 
                                    ESCRITA POR MUJERES HA SIDO LEÍDA E INCLUIDA EN EL CANON LITERARIO. EN ESTE SENTIDO, ES FUNDAMENTAL VALORAR SU PRODUCCIÓN EN 
                                    FUNCIÓN DE SUS MÉRITOS Y DE SU CONTRIBUCIÓN A LOS DEBATES INTELECTUALES DE SU TIEMPO.
                                </p>
                            </div>
                
                            <!-- Lado derecho con la imagen centrada y el texto debajo -->
                            <div class="p-3" style="flex: 1; display: flex; justify-content: center; align-items: center; flex-direction: column;">
                                <a href="https://hdl.handle.net/20.500.14428/34733" target="_blank">
                                    <img style="width:100%; height: auto; object-fit: cover;" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-002.png">
                                </a><br>
                                <p class="font-12 text-center fontMS300Italic">
                                    [Retrato de Angélica Palma Román] [fotografía]. Lima: Courret Hermanos, 19-?. 1 negativo sobre placa
                                    de vidrio : gelatino bromuro ; 13 x 18 cm. Patrimonio Cultural de la Nación. <br><br>
                                    Disponible en: <a href="https://hdl.handle.net/20.500.14428/34733" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

                <p class="fontMS300 text-center font-24">
                    <br><br>
                    REDESCUBRIR LA OBRA DE ANGÉLICA PALMA IMPLICA NO SOLO UN ACTO DE JUSTICIA LITERARIA, SINO
                    TAMBIÉN UNA RELECTURA CRÍTICA DE LOS MECANISMOS QUE HAN DETERMINADO QUÉ VOCES HAN SIDO
                    PRESERVADAS EN EL CANON Y CUÁLES HAN SIDO RELEGADAS A UN SEGUNDO PLANO.
                    <br><br>

                    <br>
                </p>

            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal2 font-30">
                            ANGÉLICA PALMA Y<br>
                            LA LITERATURA

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-LINEA-000.png">
                </div>
                <p class="text-center text-white fontMS300 font-24">
                    <br><br>
                    ANGÉLICA PALMA ESCRIBIÓ NOVELAS, CUENTOS Y POESÍAS EN DIVERSOS MEDIOS DE DIVULGACIÓN PERUANOS
                    COMO PRISMA, MERCURIO PERUANO, VARIEDADES Y MUNDIAL, Y EXTRANJEROS COMO HOJAS SELECTAS (BARCELONA),
                    RAZA ESPAÑOLA (MADRID), PLUS ULTRA Y CARAS Y CARETAS (BUENOS AIRES).
                    A PESAR DE SU VALÍA, LA OBRA LITERARIA DE ANGÉLICA PALMA NO HA SIDO RECONOCIDA DEBIDAMENTE: 
                    «SIEMPRE DETRÁS DEL PADRE O EN LA SOMBRA DE ESTE PARECIERA EL LUGAR QUE LA HISTORIOGRAFÍA 
                    LITERARIA LE HA CONCEDIDO A PALMA» (EVELYN SOTOMAYOR).
                    <br>
                </p>
                <div class="row p-5">
                    <div class="col-sm-1">
                        <br>
                    </div>
                    <div class="col-sm-10" style="position: relative;">
                        <!-- Imagen con posición relativa -->
                        <a href="https://hdl.handle.net/20.500.14428/65388" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-003.png" style="display: block; width: 100%; height: auto;">
                        </a>
                        
                        <!-- Texto en la parte inferior de la imagen con fondo transparente -->
                        <p class="fontMS100Italic text-center text-white font-12" style="position: absolute; bottom: -4%; width: 98%; background: #00000082;; padding-left: 2%; padding-right: 2%; padding-top: 20px; padding-bottom: 20px;">
                            [Retrato de Angélica Palma]. Lima: Courret Hermanos, 1906. 1 negativo sobre placa de vidrio : gelatino bromuro ; 18 x 13 cm.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/65388" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                        </p>
                    </div>
                    <div class="col-sm-1">
                        <br>
                    </div>
                </div>
                <p class="text-center text-white fontMS300 font-24">
                    <br><br>
                    SIN EMBARGO, A INICIOS DEL SIGLO XX, AUTORES COMO EUGENIO D’ORS, MERCEDES GAIBROIS DE BALLESTEROS, 
                    JOSÉ DE LA RIVA AGÜERO Y JOSÉ JIMÉNEZ BORJA, DESTACARON LOS APORTES LITERARIOS DE ANGÉLICA PALMA. 
                    ASÍ LO HIZO NOTAR MERCEDES GAIBROIS EN EL SIGUIENTE PRÓLOGO: «(…) AL ADVERTIRLO ASÍ LA CRÍTICA, 
                    PRODIGÓ MERECIDOS ELOGIOS A SU EXQUISITA PROSA. ANGÉLICA PALMA, PERUANA, Y ESPAÑOLA POR SU ESPÍRITU 
                    Y SU CORAZÓN, ENCARNA EL TIPO REPRESENTATIVO HISPANOAMERICANO EN UN ELEVADO SENTIDO RACIAL, 
                    QUE ESTÁ POR ENCIMA DE LOS VULGARES CONCEPTOS POLÍTICOS. EL IDIOMA, VEHÍCULO DE COMUNICACIÓN, 
                    COMUNIDAD ESPIRITUAL, PESE A LOS MATERIALISTAS DE ESTOS DÍAS, TIENE EN ANGÉLICA PASIÓN DE CULTO, 
                    FUERZA DE CONVICCIÓN, Y SUS PÁGINAS LITERARIAS, CASTIZAS, SON UNO DE ESOS LAZOS QUE ATAN VIGOROSAMENTE DOS COLUMNAS, 
                    AUNQUE ENTRE ELLAS “TIENDA INMENSO SUS OLAS EL MAR”».
                    <br><br><br>
                </p>
                

                <div class="row  mt-5">
                    
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col mx-3 md-3">
                        <a>
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-004.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Velada hogareña. Variedades: revista semanal
                            ilustrada. Año XXI, no. 892, 4 de abril de 1925. Pág. 19.
                            Epígrafe de la sección: «Capítulo de una novela
                            nacional». Capítulo de la novela Tiempos de la patria
                            vieja (Buenos Aires, 1926).<br><br>
                            Disponible en: <a href="https://cedoc.sisbib.unmsm.edu.pe/biblioteca-digital/revistas/variedades?pagina=1" target="_blank" style="color: #ffffff;">
                            <br>https://cedoc.sisbib.unmsm.edu.pe/biblioteca-digital/revistas/variedades?pagina=1</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a>
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-008.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br><br>
                            El último poeta. Variedades: revista semanal
                            ilustrada. Año XX, no. 843, 26 de abril de 1924.
                            Pág. 38. Cuento.
                            <br><br>
                            Disponible en: <a href="https://cedoc.sisbib.unmsm.edu.pe/biblioteca-digital/revistas/variedades?pagina=1" target="_blank" style="color: #ffffff;">
                            <br>https://cedoc.sisbib.unmsm.edu.pe/biblioteca-digital/revistas/variedades?pagina=1</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a>
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-009.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br><br>
                            Marianela (seud.). Variedades: revista semanal
                            ilustrada. Año XVII, no. 663, 13 de noviembre de
                            1920. Pág. 24. Poesía.<br><br>
                            Disponible en: <a href="https://cedoc.sisbib.unmsm.edu.pe/biblioteca-digital/revistas/variedades?pagina=1" target="_blank" style="color: #ffffff;">
                            <br>https://cedoc.sisbib.unmsm.edu.pe/biblioteca-digital/revistas/variedades?pagina=1</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            LAS NOVELAS<br>
                            DE ANGÉLICA PALMA

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                    </div>
                </div>
                <!-- <div class="col-sm-1"></div> -->
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio39/MARIA-WIESSE-LINEA-001.png">
                </div>

                <div class="row p-5">
                        <div class="row" style="background: #424342; padding: 0%;">
                            <div class="col-sm-6 " style="padding: 0;">
                                <a href="http://hdl.handle.net/20.500.14428/79211" target="_blank" >
                                    <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-010.png">
                                </a>
                            </div>
                            <div class="col-sm-6 p-5">
                                <p class="text-left fontMS300 text-white font-16" >
                                    <br><br>
                                    ANGÉLICA PALMA ESCRIBIÓ OCHO NOVELAS Y DOS
                                    BIOGRAFÍAS NOVELADAS. EN CASI TODAS ELLAS, TRATA
                                    DE TEMAS PERUANOS Y EL AMBIENTE ES LIMEÑO. REVIVIÓ
                                    EL PASADO VIRREINAL EN COLONIAJE ROMÁNTICO; LA
                                    ETAPA DE LA EMANCIPACIÓN, EN TIEMPOS DE LA PATRIA
                                    VIEJA; Y TRATÓ DE LA REPÚBLICA, AL ESCRIBIR LA
                                    BIOGRAFÍA DE RICARDO PALMA.<br><br><br><br><br>
                                    <span class="fontMS300Italic font-12 ">
                                        [Retrato de Ricardo Palma, acompañado de sus hijos, hijas y nietas]<br>
                                        Disponible en: <a href="http://hdl.handle.net/20.500.14428/79211" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                                        
                                    </span>
                                    
                                </p>
                            </div>
                        </div>
                </div>

                <div class="row ">
                    
                    <div class="col-sm-6 p-5">
                        <p class="text-justify  fontMS100 font-16">
                            <br><br>
                            COMO SEÑALA SIRVENT DE LUCA, «SUS NOVELAS NO
                            DESTACAN POR SER EXCEPCIONALES NI DIFERENTES,
                            INCLUSO SE PODRÍA DECIR QUE NO CUENTAN NADA QUE
                            NO HAYA SIDO CONTADO ANTES. RECUERDAN LAS
                            NOVELAS DE LA GENERACIÓN DE SU PADRE, DE AQUELLA
                            BOHEMIA QUE QUISO RETRATAR LA SOCIEDAD Y
                            CONGELAR EN FORMA DE PEQUEÑOS CUADROS DE
                            COSTUMBRES, LOS ACONTECIMIENTOS DEL DÍA A DÍA. AL
                            IGUAL QUE HICIERAN BENITO PÉREZ GALDÓS, EMILIA
                            PARDO BAZÁN O MESONERO ROMANOS, ANGÉLICA
                            SUPO PINTAR PERSONAJES Y SOCIEDADES, MOMENTOS
                            <br>
                        </p>
                    </div>
                    
                    <div class="col-sm-6 p-5">
                        <p class="text-justify  fontMS100 font-16">
                            <br><br>
                            HISTÓRICOS NACIONALES Y UTILIZANDO LA TÉCNICA DEL
                            MICROSCOPIO FIJAR SU MIRADA DE NOVELISTA EN LA
                            COTIDIANEIDAD DEL DÍA A DÍA, DE LO QUE PASABA
                            DESAPERCIBIDO, DE LA FAMILIA CORRIENTE, DE LA
                            ARISTÓCRATA O DE LA QUE RESIDÍA EN UN CALLEJÓN. NO
                            CAYÓ EN EL ROMANTICISMO FÁCIL EN EL QUE LOS
                            HOMBRES CREÍAN SE TENÍAN QUE QUEDAR LAS
                            MUJERES. MÁS BIEN AL CONTRARIO, SUPO TRASCENDER
                            EL SENTIMIENTO DEL AMOR EN SUS PERSONAJES PARA
                            HABLAR DE LOS CAMBIOS SOCIALES Y POLÍTICOS QUE
                            ESTABA VIVIENDO SU PAÍS».
                            <br>
                        </p>
                    </div>
                    
                </div>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/62208" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-011.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Por senda propia : novela / Angélica Palma;
                            prólogo, José de la Riva Agüero. – Lima: E.
                            Rosay, 1921.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/62208" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/11269" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-012.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Dos hipótesis. Mundial: revista semanal ilustrada.
                            Año VI, no. 273, 4 de setiembre de 1925. Pág. 3.
                            Novela corta.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/11269" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/20361" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-013.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Desolación. Variedades: revista semanal ilustrada.
                            Año XIX, no. 802, 14 de julio de 1923. Pág. 34.
                            Epígrafe de la sección: «Cuentos nacionales».
                            Cuento.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/20361" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

                <div class="row  mt-5">
                    <div class="col-sm-1"></div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/20361" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-014.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Detalle de la obra premiada“Tiempos de la patria vieja: novela histórica” (1924)<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/20361" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/11128" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-015.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 2%; padding-right: 2%;" >
                            <br><br><br>
                            Uno de tantos : novela / Angélica Palma. –
                            Madrid: Espasa-Calpe, 1926.
                            Ejemplar dedicado por la autora a Raúl Porras
                            Barrenechea.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/11128" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/11278" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-016.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Fernán Caballero : la novelista novelable / por
                            Angélica Palma. – Madrid: Espasa-Calpe, 1931.<br><br>
                            Dedicatoria manuscrita: «Para Raúl Porras con mi
                            gran estimación intelectual y mi buena amistad».<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/11278" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/11960" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-017.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 2%; padding-right: 2%;" >
                            <br><br><br>
                            La sombra alucinante : (novela que dejó inédita
                            la autora) / Angélica Palma. – Lima: CIP, 1939.
                            <br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/11960" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal2 font-30">
                            ANGÉLICA PALMA Y<br>
                            EL PERIODISMO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-LINEA-000.png">
                </div>
                
                <div class="row p-5">
                    <div class="row" style="background: black; padding: 0%;">
                        <div class="col-sm-6" style="padding-left: 5%; padding-right: 5%; padding-top: 5%;">
                            <p class="text-right fontMS300 text-white font-16" >
                                
                                ANGÉLICA PALMA ESCRIBIÓ ARTÍCULOS PARA
                                PERIÓDICOS Y REVISTAS NO SOLO NACIONALES
                                SINO DEL EXTRANJERO. ALGUNOS DE ESTOS
                                MEDIOS FUERON LOS SIGUIENTES: MERCURIO
                                PERUANO Y VARIEDADES (PERÚ), CARAS Y
                                CARETAS, LA PRENSA Y PLUS ULTRA (BUENOS
                                AIRES) Y BOLÍVAR, FILOSOFÍA Y LETRAS, HOJAS
                                SELECTAS, RAZA ESPAÑOLA, EL SOL, CRISOL Y
                                LUZ (ESPAÑA).<br><br><br>
                            </p>
                            <p class="text-right text-white fontMS300Italic font-12 ">
                                Meza, Ladislao F. Angélica Palma (Marianela). Mundial: revista semanal
                                ilustrada. Año VI, no. 263, 26 de junio de 1925, p. [38]-[39] : retr.<br><br>
                                Disponible en: <a href="http://hdl.handle.net/20.500.14428/80728" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            </p>
                        </div>
                        <div class="col-sm-6 " style="padding: 0;">
                            <a href="http://hdl.handle.net/20.500.14428/80728" target="_blank" >
                                <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-018.png">
                            </a>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="row">
                        <div class="col-sm-6 p-5">
                            <p class="text-justify fontMS300 text-white font-16" >
                                <br><br>
                                RESPECTO A LA OBRA PERIODÍSTICA DE ANGÉLICA PALMA,
                                SIRVENT DE LUCA SEÑALA QUE «SE CONFORMÓ COMO LA
                                PRIMERA MUJER PERUANA PERIODISTA PROFESIONAL
                                QUE GANÓ UN SUELDO QUE LE PERMITIÓ COSTEAR,
                                JUNTO CON EL MONTEPÍO Y LOS DERECHOS DE LAS
                                TRADICIONES QUE RECIBÍAN LAS TRES HERMANAS, LA
                                VIDA QUE QUISO VIVIR. (…)
                                EL MUNDO SE LE QUEDÓ PEQUEÑO PUES CUALQUIER
                                COSA QUE OCURRIERA ERA DIGNA DE SER SOMETIDA A SU
                                MIRADA CRÍTICA Y RACIONAL QUE NO SE DEJABA
                                EMBARGAR POR LOS SENTIMIENTOS SALVO CUANDO DE
                                CHILE SE HABLABA.
                                
                            </p>
                        </div>
                        <div class="col-sm-6 p-5">
                            <p class="text-justify fontMS300 text-white font-16" >
                                <br><br>
                                PUBLICÓ EN LA PRIMERA PÁGINA DE DIARIOS
                                NACIONALES HABLANDO DE POLÍTICA Y DE CONFLICTOS
                                TERRITORIALES EN UN MOMENTO EN QUE LAS MUJERES
                                LUCHABAN POR CONSEGUIR EL VOTO. RECIBIÓ CRÍTICAS
                                POR ELLO PERO LEJOS DE AMEDRENTARLA, QUISO LLEVAR
                                LA POLÉMICA A SU SECCIÓN Y DEMOSTRAR QUÉ DIFÍCIL
                                IBA A SER CALLARLA.
                                QUISO MOSTRAR AL MUNDO CÓMO ERA SU PAÍS, PERÚ, Y
                                CÓMO ERAN SUS HABITANTES, SU CULTURA, SU FORMA
                                DE VER LA VIDA, CÓMO CONSERVABAN MUCHAS DE LAS
                                COSTUMBRES QUE LOS ESPAÑOLES HABÍAN DEJADO Y
                                CÓMO NO OLVIDABAN SU PASADO INCAICO».
                                
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row  mt-5">
                    <div class="col-sm-4">
                        <a >
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-019.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%;" >
                            <br><br>
                            Marianela [seud. Angélica Palma], De la capital
                            castiza. Variedades: revista semanal ilustrada.
                            Año XVIII, no. 733, 18 de marzo de 1922. Pág. 32.<br><br>
                            Aborda el tema de las veladas literarias del
                            Ateneo de Madrid. Repasa la historia de este
                            centro intelectual desde su fundación. Cita alguna
                            de las conferencias a las que ha asistido y termina
                            recordando la conferencia por parte de los
                            estudiantes hispanoamericanos acerca de la vida
                            universitaria en sus países.<br><br>
                            Disponible en: <a href="https://cedoc.sisbib.unmsm.edu.pe/biblioteca-digital/revistas/variedades?pagina=1" target="_blank" style="color: #ffffff;">
                            <br>https://cedoc.sisbib.unmsm.edu.pe/biblioteca-digital/revistas/variedades?pagina=1</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a >
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-020.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%;" >
                            <br><br>
                            La cuna maternal de Chorrillos. Variedades:
                            revista semanal ilustrada. Año XXI, no. 909, 1 de
                            agosto de 1925. Pág. 37.<br>
                            Epígrafe de la sección: «Por la patria y por la
                            raza».<br><br>
                            Monográfico sobre la cuna maternal fundada por
                            doña Juana Alarco de Dammert y situada en
                            Chorrillos a raíz de una visita que realiza Angélica
                            Palma.<br><br>
                            Disponible en: <a href="https://cedoc.sisbib.unmsm.edu.pe/biblioteca-digital/revistas/variedades?pagina=1" target="_blank" style="color: #ffffff;">
                            <br>https://cedoc.sisbib.unmsm.edu.pe/biblioteca-digital/revistas/variedades?pagina=1</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a >
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-023.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #424342; padding-left: 5%; padding-right: 5%;" >
                            <br><br><br>
                            La mujer y la moda. Variedades: revista
                            semanal ilustrada. Año XXV, no. 1096, 6 de
                            marzo de 1929. Pág. 126.<br><br>
                            Artículo escrito para el número conmemorativo
                            de la revista donde repasa la evolución que ha
                            sufrido la vestimenta de la mujer peruana a lo
                            largo de los años.<br><br>
                            Disponible en: <a href="https://cedoc.sisbib.unmsm.edu.pe/biblioteca-digital/revistas/variedades?pagina=1" target="_blank" style="color: #ffffff;">
                            <br>https://cedoc.sisbib.unmsm.edu.pe/biblioteca-digital/revistas/variedades?pagina=1</a>               
                            <br><br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO"style="background-image: url('/assets/images/micrositio/micrositio40/ANGELICA-PALMA-025.png'); background-size: cover; background-position: center; background-repeat: no-repeat;">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-LINEA-001.png" width="90%" style="margin-left: 5%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100Italic font-18">
                            <br>
                            <span>
                                <br><br>
                                «TAMBÍEN DIMANABA EN ELLA DE SU HONDA PIEDAD FILLIAL, Y ERA COMO LA HEREDADA FUENTE DE SU CAUDAL ARTÍSTICO, EL CRIOLLISMO HISPANIZANTE,
                                EL AMOR A LA LIMA VIEJA, AL HISTÓRICO PERÚ Y A LA MADRE PATRIA ESPAÑA. DÓCIL A LAS INSPIRACIONES PATERNAS, A LA CONTINUIDAD EN LA SANGRE,
                                EN EL ESPÍRITU Y EN EL TIEMPO, ERA LA CABAL ANTÍTESIS DE LOS DESARRAIGADOS Y LOS DESCASTADOS. SU VIDA Y SU OBRA EVOCAN LA IMAGEN DE UNA 
                                LÁMPARA VOTIVA».<br><br>
                                (JOSÉ DE LA RIVA AGÜERO. «DISCURSO». 1936)  
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-LINEA-002.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-LINEA-003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            ANGÉLICA PALMA:<br>
                            EN EL NOMBRE DEL PADRE

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-LINEA-003.png">
                    </div>
                </div>
                <!-- <div class="col-sm-1"></div> -->
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-LINEA-003.png">
                </div>

                <div class="row p-5">
                        <div class="row">
                            <div class="col-sm-7 p-5">
                                <p class="text-right fontMS300  font-20" >
                                    <br>
                                    RESPECTO A LA RELACIÓN ENTRE RICARDO Y
                                    ANGÉLICA PALMA, LUIS FERNÁN CISNEROS ANOTÓ
                                    LO SIGUIENTE: «LA HIJA FUE TODO PARA EL PADRE
                                    ILUSTRE; SU DEBILIDAD PRIMERO; SU VANIDAD
                                    DESPUÉS; SU AMIGA MÁS TARDE; SU
                                    COLABORADORA LUEGO; SU LAZARILLO EN LA
                                    DECREPITUD Y LA MANO QUE APRETÓ
                                    LARGAMENTE EN LA AGONÍA. HOY ERA LA MIRADA
                                    FIJA QUE LO SEGUÍA EN EL MÁS ALLÁ. PERO
                                    TAMBIÉN ERA SU HEREDERA UNIVERSAL EN EL AFÁN
                                    DEL ARTE, EN EL AMOR A LA HISTORIA, EN LA
                                    AUSTERIDAD Y EN LA POBREZA LIMPIA».<br><br>
                                    
                                </p>
                            </div>
                            <div class="col-sm-5 ">
                                <a href="https://hdl.handle.net/20.500.14428/6523" target="_blank" >
                                    <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-026.png">
                                </a>
                                <p class="text-center fontMS300Italic text-white font-14 p-3" style="background: #000000; padding-left: 2%; padding-right: 2%;">
                                    
                                    [Retrato de Angélica Palma niña]. Lima: Courret Hermanos, 1891.
                                    1 negativo sobre placa de vidrio : gelatino bromuro ; 12 x 9 cm.<br><br>
                                    Patrimonio Cultural de la Nación.<br><br>
                                    Disponible en: <a href="https://hdl.handle.net/20.500.14428/6523" target="_blank" style="color: #ffffff;">
                                    Biblioteca Digital</a>     
                                </p>
                            </div>
                        </div>
                </div>
                <p class="text-center  fontMS500 font-24">
                    <br><br>
                    LA RELACIÓN ENTRE ANGÉLICA PALMA Y SU PADRE, RICARDO PALMA, SE MANIFIESTA NO SOLO EN EL
                    ÁMBITO FAMILIAR, SINO TAMBIÉN EN EL TERRENO LITERARIO. SU VÍNCULO ESTUVO MARCADO POR EL
                    DIÁLOGO INTELECTUAL, EL AFECTO MUTUO Y LA TRANSMISIÓN DE UN LEGADO LITERARIO QUE
                    ANGÉLICA CULTIVÓ CON DEDICACIÓN.
                    <br>
                </p>

                <div class="row p-5">
                    <div class="row" style="background: #424342; padding: 0%;">
                        <div class="col-sm-5 " style="padding: 0;">
                            <a href="https://hdl.handle.net/20.500.14428/11491" target="_blank" >
                                <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-027.png">
                            </a>
                        </div>
                        <div class="col-sm-7 " style="padding-left: 5%; padding-right: 5%; padding-top: 5%;">
                            <p class="text-left fontMS300 text-white font-14" >
                                
                                UNO DE LOS TESTIMONIOS MÁS REVELADORES DE ESTA RELACIÓN ES SU LIBRO
                                "RICARDO PALMA", EN DONDE ANGÉLICA NO SOLO RECONSTRUYE LA VIDA Y OBRA
                                DE SU PADRE, SINO QUE PRESENTA SU FIGURA CON UNA MIRADA ÍNTIMA Y
                                REFLEXIVA. A TRAVÉS DE ESTA OBRA, SE ERIGE COMO SU BIÓGRAFA Y DIFUSORA,
                                CONSOLIDANDO SU PAPEL EN LA PRESERVACIÓN DE SU MEMORIA.
                                POR OTRO LADO, EN LAS CARTAS QUE SE ADJUNTAN SE APRECIAN ALGUNOS
                                MOMENTOS DE LA VIDA COTIDIANA Y CULTURAL DE ANGÉLICA PALMA: SUS
                                EXÁMENES EN EL COLEGIO DIRIGIDO POR TERESA GONZÁLEZ DE FANNING, SU
                                ESTANCIA EN ESPAÑA Y LA PUBLICACIÓN DE POEMAS EN SU ÁLBUM DE
                                AUTÓGRAFOS.<br>
                                FINALMENTE, PUEDEN APRECIARSE ALGUNAS CARTAS QUE REFLEJAN EL PAPEL
                                ACTIVO DE ANGÉLICA PALMA EN LA DIFUSIÓN DE LA OBRA DE SU PADRE.<br><br>
                                <span class="fontMS300Italic font-12 ">
                                    Ricardo Palma / por Angélica Palma. – Buenos Aires, 1933. Pág. 8.
                                    «Edición del centenario del tradicionista (7 de febrero de 1933) con numerosas ilustraciones
                                    documentales».<br><br>
                                    Disponible en: <a href="https://hdl.handle.net/20.500.14428/11491" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                                    
                                </span>
                                
                            </p>
                        </div>
                    </div>
                </div>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/46410" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-028.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12 p-3" style="background: #000000;" >
                            <br><br>
                            [Carta de Teresa González de Fanning para
                            Ricardo Palma]. Lima, 27 y 28 de diciembre de
                            1886. 2 f. Manuscritos firmados.<br><br>
                            La autora solicita a Palma presenciar los
                            exámenes que rendirán las chicas de segundo y
                            tercer grado de primaria, así mismo le comenta
                            que los exámenes de Angélica (hija de Ricardo
                            Palma) se rendirán los días 3, 4 y 5 de enero. En la
                            carta le pide pueda tener en su poder unos días
                            más la novela Regina, hasta que termine el
                            ajetreo de los exámenes. En la siguiente carta le
                            comenta que recibió su carta y los ejemplares de
                            Regina, de los cuales de siente orgullosa de que
                            haya viajado y presentado ante varias personas,
                            le envía un ejemplar para para la señorita Maffo y
                            otro para la señora Gorriti.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/46410" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/47778" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-029.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12 p-3" style="background: #000000;" >
                            <br><br><br><br>
                            [Carta de Manuel Tamayo y Baus para Ricardo
                            Palma]. [Madrid], 18 de setiembre [de 1892]. 1 f.<br><br>
                            Manuscrito firmado. En papel membretado: «Real
                            Academia Española. Secretaría».<br><br>
                            Manuel Tamayo y Baus le comenta a Ricardo
                            Palma que le está devolviendo con su firma el
                            álbum de su hija Angélica, y que pudo conversar
                            con el señor Cánovas sobre el problema que
                            Palma tuvo con su equipaje, ya que esperan que
                            este no se lleve ningún disgusto en España.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/47778" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/47771" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-030.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12 p-3" style="background: #000000;" >
                            <br><br>
                            [Carta de Montaner y Simón para Angélica
                            Palma]. Barcelona, 27 de febrero de 1920. 1 f.
                            Manuscrito firmado.<br>
                            Papel membretado de «Corresponsales en todas
                            las repúblicas americanas. Montaner y Simón,
                            calle de Aragón n°255. Teléfono A-386. Dirección
                            telegráfica: ‘Montamin’. Clave: Lieber’s Code
                            Used».<br><br>
                            Montaner y Simón le confirman a Angélica
                            Palma que recibieron su tarjeta, y le desean
                            completa resignación por la muerte de su padre
                            don Ricardo Palma. Agregan que don Palma les
                            había comentado que tenía el proyecto de
                            publicar una edición de sus Tradiciones
                            peruanas, y desean que doña Angélica les diga
                            algo sobre ello pues les interesa el asunto.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/47771" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/18253" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-031.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12 p-3" style="background: #000000;" >
                            
                            [Carta de Casimiro Prieto para Ricardo
                            Palma]. Buenos Aires, 16 de diciembre
                            de 1893. 4 f. Manuscrito firmado.
                            Anotación manuscrita en la parte
                            superior de la primera página.<br><br>
                            Patrimonio Cultural de la Nación.<br><br>
                            En esta carta, el escritor y periodista
                            español se disculpa por la demora en
                            responder a su última carta, ya que
                            estaba con muchas tareas. Felicita a
                            Palma y a su hija Angélica por los
                            reconocimientos obtenidos en España,
                            habiéndose enterado por los periódicos.
                            Indica que le envía un nuevo volumen
                            tanto para Palma como para la
                            Biblioteca Nacional. Además solicita que
                            le pueda enviar nuevos escritos inéditos
                            para que los publique en la revista.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/18253" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/78130" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-032.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12 p-3" style="background: #000000;" >
                            
                            [Carta de Cristina a Angélica Palma]. La
                            Paz, 10 de noviembre de 1919. 3 f.
                            Manuscrito firmado.<br><br>
                            Cristina le escribe a Angélica Palma con
                            motivo de la muerte de Ricardo Palma.<br>
                            Dice haber visto de cerca su
                            consagración absoluta a su padre, por lo
                            que comprende el vacío inmenso que
                            sentirá. No ha dejado de pensar en la
                            familia de Palma desde que se enteró de
                            la noticia y, si no ha podido escribir
                            antes, ha sido porque el correo por
                            Mollendo estaba interrumpido, y no
                            quería arriesgarse a que su carta se
                            pierda y Angélica piense que no le había
                            escrito. Le envía saludos también a las
                            hermanas de Angélica, especialmente a
                            Augusta, y dice que Enrique ha sentido
                            muy sinceramente su desgracia.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/78130" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/72387" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-033.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12 p-3" style="background: #000000;" >
                            <br><br><br><br>
                            [Carta de Joaquín José de Osma para
                            Ricardo Palma]. [Madrid], 10 de enero
                            de 1893. 1 f.<br><br>
                            Manuscrito firmado.<br><br>
                            Joaquín José de Osma le devuelve a
                            Ricardo Palma el álbum de su hija
                            Angélica y le agradece por haber
                            pensado en él para que lo firme. Le
                            comenta también que sigue mal de
                            salud.
                            <br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/72387" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br><br><br><br><br><br><br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/41138" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio40/ANGELICA-PALMA-034.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12 p-3" style="background: #000000;" >
                            <br><br><br><br>
                            [Carta de Imprenta “El Progreso” para
                            Angélica Palma]. Callao, 10 de agosto de
                            1920. 1 f.<br><br>
                            Manuscrito firmado.<br><br>
                            En papel membretado: «Imprenta El
                            Progreso. Gálvez 41 y Libertad 56
                            Callao».<br><br>
                            Carta dirigida a Angélica Palma, en la
                            cual se le informa sobre la situación de
                            las ventas de las obras de Ricardo
                            Palma.
                            <br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/41138" target="_blank" style="color: #ffffff;">
                            Biblioteca Digital</a>               
                            <br><br><br><br><br><br><br><br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>
            </div>
        </div>
    </div>
</div>




<div class="fondoMorado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio34\FERNANDOG-LINEA-004.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 p-3">
                        <p class="fontMS100 text-white font-24">
                            Evelyn Sotomayor, al analizar la trascendencia de la obra de Angélica Palma sostiene lo siguiente:
                        </p>
                    </div>
                    <div class="col-sm-12 p-3">
                        <p class="fontMS100 text-white font-24 text-justify">
                            «Hacemos un acto de justicia leyendo a Angélica Palma, la escritora y no a la sombra del padre literato como la hija sacrificada.
                            Si es tarea de las generaciones venideras rescatar la memoria de los que precedieron, entonces estamos a tiempo de reescribir
                            o enmendar la historiografía. Sin romanticismo ni a las sombras de padres o amantes, las mujeres han contado con suficientes
                            herramientas y estrategias para abrirse camino en lo que decidieran emprender. En el caso que hemos revisado, haríamos
                            justicia real al leer a Angélica Palma en su verdadera dimensión de escritora y no detrás o la sombra del padre. Su pluma
                            registra sus propios méritos literarios que trascienden el apellido que llevaba».
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            Pregunta 1: ¿De qué manera la
                            historiografía literaria ha invisibilizado
                            o minimizado el trabajo de escritoras
                            como Angélica Palma, y cómo
                            podemos contribuir a una
                            revalorización justa de su obra?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            Pregunta 2: ¿Hasta qué punto el
                            parentesco con figuras literarias
                            influyentes puede afectar la
                            percepción y reconocimiento de la
                            producción intelectual de una
                            escritora?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            Pregunta 3: ¿Qué estrategias han
                            utilizado las escritoras a lo largo de la
                            historia para abrirse camino en un
                            ámbito dominado por figuras
                            masculinas, y cómo estas estrategias
                            pueden servir de referencia en la
                            actualidad?
                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center  font-40" style="color:#bb32ac;">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS100 text-left font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Gaibrois de Ballesteros, M. (1926). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">En honor de
                                Angélica Palma. En Palma, A. Uno de tantos. Madrid:
                                Espasa-Calpe, p. 7-10.<br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Pollarolo, G. (2019).</span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Epílogo (para leer antes o
                                después). En Palma, A. Contando cuentos.
                                Ilustraciones de Christian Ayuni, p. 141-154.<br>
                                <!-- Gafas Moradas EIRL.
                                <br><br>
                                Disponible en: 
                                <a style="color: #000000;" href="https://doi.org/10.1590/1982-25532020144547" target="_blank">
                                https://doi.org/10.1590/1982-25532020144547</a>
                                <br> -->
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Posadas, R. M. (1943). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Las novelas de Angélica Palma:
                                estudio crítico-biográfico, con una síntesis de una
                                novela. Lima: Empresa Periodística La Prensa.<br></span>

                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Sirvent de Luca, M. P. (2012). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Angélica Palma: su vida
                                y su obra (1878-1935). Madrid: Universidad
                                Complutense de Madrid, Facultad de Filología.
                                Memoria para optar el grado de Doctor.
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Sociedad Amigos de Palma (1937).</span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Angélica Palma.
                                Lima: Sociedad Amigos de Palma.<br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Sotomayor, E. (2022). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Trascender la figura del padre:
                                el caso de Angélica Palma (Lima, 1878-Rosario, 1935).
                                En Palma, A. Ricardo Palma, el tradicionista. Lima:
                                Universidad Científica del Sur, p. 11-21.
                            </span>

                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
